import {FC} from 'react'

import {Modal} from 'react-bootstrap'
import {KTSVG} from '../../../../../../_metronic/helpers'
import WSButton from '../../../../../../_metronic/helpers/components/WSButton/WSButton'

export type StaggerConfirmationModalProps = {
  show: boolean
  completeDate: string
  completeMinute: string
  handleClose: () => void
  handleSubmit: () => void
}

const WriteModal: FC<StaggerConfirmationModalProps> = (props) => {
  const {completeDate, completeMinute,  show, handleClose, handleSubmit} = props

  return (
    <Modal
      id='kt_modal_create_app'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-dialog-centered mw-700px h-auto'
      show={show}
      onHide={handleClose}
    >
      <div className='scroll-x'>
        <div className='modal-header'>
          <h2 className='fs-2'>Sent Stagger Message Confirmation</h2>
          <div
            className='btn btn-icon btn-sm'
            onClick={() => {
              handleClose()
            }}
          >
            <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
          </div>
        </div>
        <div className='modal-body text-center fs-3'>
          <h2>
          This will take {completeMinute} minute to complete. The last message will be sent by {completeDate}
          </h2>
          <small>Do you want to send it ?</small>
        </div>

        <div className='modal-footer'>
          <div className='container d-flex align-items-end justify-content-end mt-6 mb-5'>
            <WSButton
              type='submit'
              className='btn btn-lg btn-light-primary me-5 fw-500'
              onClick={() => {
                handleClose()
              }}
            >
              <span className='indicator-label'>Cancel</span>
            </WSButton>
            <WSButton
              type='submit'
              className='btn btn-lg btn-primary fw-500'
              onClick={() => handleSubmit()}
            >
              <span className='indicator-label'>Send Message</span>
            </WSButton>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default WriteModal
